import { render } from "./ItemDeSelecao.vue?vue&type=template&id=2cbf6305&ts=true"
import script from "./ItemDeSelecao.vue?vue&type=script&lang=ts"
export * from "./ItemDeSelecao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__